import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SyncAltRoundedIcon from '@mui/icons-material/SyncAltRounded';
import FlashOnRoundedIcon from '@mui/icons-material/FlashOnRounded';
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import RepeatRoundedIcon from '@mui/icons-material/RepeatRounded';
import { useLanguage } from '../contexts/LanguageContext';

export default function Highlights() {
  const { translations } = useLanguage();
  const highlights = translations.highlights_section;

  const items = [
    { icon: <SyncAltRoundedIcon />, title: highlights.adaptable_performance_title, description: highlights.adaptable_performance_description },
    { icon: <FlashOnRoundedIcon />, title: highlights.built_to_last_title, description: highlights.built_to_last_description },
    { icon: <CardGiftcardRoundedIcon />, title: highlights.great_user_experience_title, description: highlights.great_user_experience_description },
    { icon: <CampaignRoundedIcon />, title: highlights.innovative_functionality_title, description: highlights.innovative_functionality_description },
    { icon: <RocketLaunchRoundedIcon />, title: highlights.reliable_support_title, description: highlights.reliable_support_description },
    { icon: <RepeatRoundedIcon />, title: highlights.precision_detail_title, description: highlights.precision_detail_description },
  ];

  return (
    <Box
      id="highlights"
      sx={{
        py: { xs: 8, sm: 14 },
        background: 'linear-gradient(180deg, rgba(245,243,255,0.5), rgba(255,255,255,1))',
      }}
    >
      <Container>
        <Stack spacing={2.5} sx={{ mb: 6, maxWidth: 720 }}>
          <Chip label={translations.highlights} color="primary" variant="outlined" sx={{ alignSelf: 'flex-start' }} />
          <Typography component="h2" variant="h3" sx={{ color: 'text.primary' }}>
            {highlights.title}
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, maxWidth: 620 }}>
            {highlights.description}
          </Typography>
        </Stack>

        <Grid container spacing={2.5}>
          {items.map((item) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.title}>
              <Stack
                direction="column"
                component={Card}
                spacing={1.25}
                useFlexGap
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 4,
                  borderColor: 'divider',
                  boxShadow: '0 16px 40px rgba(76, 29, 149, 0.08)',
                }}
              >
                <Box sx={{ color: 'primary.main', opacity: 0.95 }}>{item.icon}</Box>
                <Typography variant="h6">{item.title}</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                  {item.description}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
